import { toast } from 'sonner';
import type { OutreachOperation } from '@discovr/types';
import { failedTotal } from '../operationOutcomes';
import { summarizeApprove } from './approveSummary';
import { failedReasons, sendFinishedText } from './bulkSendCopy';

/** RULES "Toast on finish": says how a bulk send ended, whether or not the wizard is still open. */
export function toastSendFinished(operation: OutreachOperation, scheduled: boolean) {
  const { sentIds, waitingEmailIds } = summarizeApprove(operation);
  const failed = failedTotal(operation);
  const text = sendFinishedText({ sent: sentIds.length, waiting: waitingEmailIds.length, skipped: operation.skippedCount, failed, scheduled, total: operation.total, reasons: failedReasons(operation) });
  const nothingWent = sentIds.length + waitingEmailIds.length === 0;
  if (failed > 0 && nothingWent) toast.error(text);
  else if (failed === 0 && !nothingWent) toast.success(text);
  else toast.warning(text);
}
